import { render, staticRenderFns } from "./RoleGrantColumn.vue?vue&type=template&id=0cb87585&scoped=true&"
import script from "./RoleGrantColumn.vue?vue&type=script&lang=js&"
export * from "./RoleGrantColumn.vue?vue&type=script&lang=js&"
import style0 from "./RoleGrantColumn.vue?vue&type=style&index=0&id=0cb87585&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb87585",
  null
  
)

export default component.exports